const getters = {
    sidebar: state => state.app.sidebar,
    visitedViews: state => state.app.visitedViews,
    navbarData: state => state.app.navbarData,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    roles: state => state.user.roles,
    guid: state => state.user.agent_guid,
    appSysTime: state => state.app.systemTime,
    examineRemind: state => state.app.examineRemind,
    whiteListType: state => state.app.whiteListType,
    auditShopInfo: state => state.app.auditShopInfo,
    permissions: state => state.user.permissions,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js